import t from "@/lang/lang";

/** Mirrors `servicevariation.Kind`, backend/core/omni/domain/servicevariation/kind.go. */
export const ServiceVariation = {
  Zero: "",
  WRHFullService: "wrh-full-service",
  WRHKauf: "wrh-kauf",
} as const;

export type ServiceVariation =
  (typeof ServiceVariation)[keyof typeof ServiceVariation];

const serviceVariationsOf: Record<string, ServiceVariation[]> = {
  WRH: [ServiceVariation.WRHFullService, ServiceVariation.WRHKauf],
};

/**
 * serviceVariationLabel returns the name of the service variation for users, ""
 * for none, see `servicevariation.Kind.German`.
 */
export function serviceVariationLabel(serviceVariation: string): string {
  switch (serviceVariation) {
    case ServiceVariation.WRHFullService:
      return t("Full-Service");
    case ServiceVariation.WRHKauf:
      return t("Kauf");
    default:
      return "";
  }
}

// A select item cannot have the empty value of no service variation.
const noServiceVariationSelectValue = "none";

/**
 * serviceVariationSelectItems returns the items selecting a service variation
 * of the service kind: "Keine" and its service variations, see
 * `servicevariation.KindsOf`.
 */
export function serviceVariationSelectItems(
  serviceKind: string,
): { value: string; label: string }[] {
  return [
    { value: noServiceVariationSelectValue, label: t("Keine") },
    ...(serviceVariationsOf[serviceKind] ?? []).map((serviceVariation) => ({
      value: serviceVariation,
      label: serviceVariationLabel(serviceVariation),
    })),
  ];
}

/** serviceVariationToSelectValue returns the value of serviceVariation in the select items. */
export function serviceVariationToSelectValue(
  serviceVariation: string,
): string {
  return serviceVariation === ServiceVariation.Zero
    ? noServiceVariationSelectValue
    : serviceVariation;
}

/** serviceVariationFromSelectValue returns the service variation of a select item value. */
export function serviceVariationFromSelectValue(
  value: string,
): ServiceVariation {
  return value === noServiceVariationSelectValue
    ? ServiceVariation.Zero
    : (value as ServiceVariation);
}
